export enum WeekDaysEnum {
    monday = 'Lunedì',
    tuesday = 'Martedì',
    wednesday = 'Mercoledì',
    thursday = 'Giovedì',
    friday = 'Venerdì',
    saturday = 'Sabato',
    sunday = 'Domenica'
}

export const ORDERED_WEEK_DAYS: (keyof typeof WeekDaysEnum)[] = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];